import _ from 'lodash';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AfterViewInit, Component, ElementRef, NgZone, ViewChild } from '@angular/core';
import { CorpInfo, ForwarderService, License, License2, Office, Office2, Shipper, Shipper2, Contact, Contact2, Speciality, PagerService, CorpInfoTemp, Region, OceanLineService, OceanLine, Liner, CorpFile, GmapLogService } from '../../../services/index'
import { REST_API_REQUEST_CALL_URL, Util } from '../../../utils/index';
import { UserService, UserModel, LoadingService, Corporation, AlertService } from '../../../services/index'
import { MapsAPILoader } from '@agm/core';
import { FileUploader } from 'ng2-file-upload';
import { ActivatedRoute, ParamMap, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { CKEditorComponent } from 'ng2-ckeditor';
import { DataSelectorComponent } from 'app/components';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ApiService } from 'app/services/api.service';
declare var moment:any;

declare var $:any;
declare var google:any;

@Component({
  selector: 'container-corp',
  templateUrl: 'corp-setting.html'
})
export class CorpSettingComponenet implements AfterViewInit {
  corpInfo: CorpInfo = new CorpInfo();

  phoneFormatter: Function = Util.phoneFormatter;
  getLocalDtmStr:Function = Util.getLocalDtmStr;

  @ViewChild("corpAddress")
  corpAddressSearch: ElementRef;

  @ViewChild("fileInput")
  fileInput1: ElementRef;

  @ViewChild("fileInput2")
  fileInput2: ElementRef;

  // @ViewChild("fileInput3")
  // fileInput3: ElementRef;
  
  autoComplete;

  uploader: FileUploader = new FileUploader({});
  uploader2: FileUploader = new FileUploader({});
  // uploader3: FileUploader = new FileUploader({});
  
  specialityItemList;
  licenseItemList;

  isSaving: boolean = false;

  apiUrl: string = '';

  showCompanyUsers: boolean = false;
  showCfs: boolean = false;
  showCorpTemp: boolean = false;

  officeList: Array<Office2> = [];
  licenseList: Array<License2> = [];
  shipperList: Array<Shipper2> = [];
  contactList: Array<Contact2> = [];

  filePreviewPath: SafeUrl;
  filePreviewPath3:SafeUrl;

  userInfo: UserModel = new UserModel();

  forwarderWarning: string = null;

  regNumberTemp: string = '';  
  regNumberCheck: boolean = true;
  corpId:number;

  updateCorpStatusSub:Subscription;

  startDt: string = moment(new Date()).format('YYYYMMDD');
  endDt: string = moment(new Date()).format('YYYYMMDD');

  pager: any = {};
  pagedItems: Array<CorpInfoTemp> = new Array();

  changeBeforeLineCd;

  ckEditorConfig = {
    extraPlugins: 'divarea, resize, image2, image, wysiwygarea, templates',
    contentsCss: '/dist/styles/style.css',
    uiColor: '##fffa65',
    height: 500,
  };

  contactPager: any = {};
  contactPagedItems: any[];

  reqModifyTempList:Array<CorpInfoTemp> = new Array();

  corpTempId:number;

  @ViewChild("ckEditor") ckEditor: CKEditorComponent;

  //회사 컨설팅 요청 셋팅
  isOpenCcs:boolean = false;
  isServiceRouteOpen: boolean = false;
  specialityListForCcs:Array<Speciality> = new Array();
  regionListForCcs:Array<Region> = new Array();
  oceanLineList:Array<OceanLine> = new Array();

  isOpenChangeUserModal:boolean = false;

  userList:Array<UserModel> = new Array();
  selectedUser:UserModel = null;

  @ViewChild("userSelector")
  userSelector: DataSelectorComponent;


  showFileUploadModal:boolean = false;
  corpFiles:CorpFile[] = [];

  corpFileForm = new FormGroup({
    fileTitle: new FormControl(null, Validators.required),
    file: new FormControl(null, Validators.required)
  });

  fileUpLoading:boolean = false;

  getLocaleTime:Function = Util.getLocaleTime;

  constructor(
    private forwarderService: ForwarderService,
    private userService: UserService,
    private loadingService: LoadingService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private router:Router,
    private pagerService: PagerService,
    private oceanLineService: OceanLineService,
    private gmapLogService: GmapLogService,
    private apiService: ApiService
  ) {
    this.uploader2.onAfterAddingFile = (fileItem) => {
      this.filePreviewPath  = this.sanitizer.bypassSecurityTrustUrl((window.URL.createObjectURL(fileItem._file)));
    }
  }

  ngOnInit() {
    // File Upload
    // var droppedFiles = false;
    // var fileName = '';
    // var $dropzone = $('.dropzone');

    // $dropzone.on('drag dragstart dragend dragover dragenter dragleave drop', function(e) {
    //   e.preventDefault();
    //   e.stopPropagation();
    // })
    // .on('drop', function(e) {
    //   droppedFiles = e.originalEvent.dataTransfer.files;
    //   fileName = droppedFiles[0]['name'];
    //   $('.filename').html(fileName);
    //   $('.dropzone .upload').hide();
    //   $('.dropzone .title').hide();
    // });
    // $("input:file").change(function (){
    //   fileName = $(this)[0].files[0].name;
    //   $('.filename').html(fileName);
    //   $('.dropzone .upload').hide();
    //   $('.dropzone .title').hide();
    // });
    this.route.paramMap.subscribe((params: Params) => {
      this.corpId = params.params.corpId;

      if(this.corpId == null || this.corpId == undefined || this.corpId == -1) {
        this.corpId = -1;
        this.officeList.push(new Office2());
      }
      
      if(this.corpId != - 1){
        this.getCorpInfo(this.corpId);

        this.getCorpFile();
      }     
    });

    this.forwarderService.getSpecialItemList().subscribe(
      resp=> {
        if(resp.result) {
          this.specialityItemList = resp.data;
        }
      } 
    );

    this.forwarderService.getLicenseItemList().subscribe(
      resp=> {
        if(resp.result) {
          this.setLicenseItemList(resp.data);
        }
      }
    );
    
    this.oceanLineService.getOceanLines().subscribe(
      res => {
        if(res.result){
          this.oceanLineList = res.data;
        }
      }
    );

    // this.userService.getUserInfoObs().subscribe(
    //   userInfo => {
    //     this.userInfo = userInfo;
    //     if(this.corpInfo.corpId == null || this.corpInfo.statusCd === 2) {
    //       if(userInfo.jobTp === '1') {
    //         this.corpInfo.typeCd = 1;
    //       } else if(userInfo.jobTp === '2') {
    //         this.corpInfo.typeCd = 3;
    //       }
    //     }
		// 	}
    // )
    this.apiUrl = REST_API_REQUEST_CALL_URL.BASE_URL;
  }

  getCorpFile() {
    this.corpFiles = [];
    this.forwarderService.getCorpFiles(this.corpId, (resp: CorpFile[]) => {
      resp.map(file => {
        let splitWithDot = _.split(file.fileName, '.');
        let fileType = _.toLower(_.last(splitWithDot));
        
        file.fileType = fileType;
        
        if(!_.isEmpty(splitWithDot)) file.type = this.switchFileType(fileType);
        else file.type = null;
        
        this.corpFiles.push(file);
      })
    })
  }

  switchFileType(fileType) {
    switch (fileType) {
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
        return 'image';
      case 'pdf':
        return 'pdf';
      case 'excel':
      case 'xml':
      case 'xlsx': 
      case 'csv':
      case 'xlsm':
      case 'xls':
        return 'excel';
      default:
        break;
    }
  }

  refreshSearch(){
    this.handleShowCorpTemp();
    this.getCorpInfo(this.corpId);
  }

  setCorpTempPage(page:number){

    this.pager = this.pagerService.getPager(this.reqModifyTempList.length, page, 3);

    // if (page < 1) {
    //   return;
    // }

    if(page > this.pager.totalPages) {
      this.pager = this.pagerService.getPager(this.reqModifyTempList.length, this.pager.totalPages);
    }

    this.pagedItems = this.reqModifyTempList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  getCorpInfo(corpId){
    this.forwarderService.getCorpInfo(corpId).subscribe(
      resp => {
        if(resp.result) {
          this.getForwarderInfo(resp.data);
          this.forwarderWarning = null;
        } else {
          this.forwarderWarning = resp.errorMsg;
        }
      }
    );
  }

  sendGmapLog() {
		this.gmapLogService.log('corp-setting', 'PLACE');
  }

  ngAfterViewInit(): void {
    this.loadingService.isClose = true;
    if(this.forwarderWarning == null) {
      const searchInput = this.corpAddressSearch.nativeElement;
      this.mapsAPILoader.load().then(() => {
        this.autoComplete = new google.maps.places.Autocomplete(searchInput, {fields: ["name", "formatted_address"]});
        this.sendGmapLog();

        let hasDownBeenPressed = false;
        
        searchInput.addEventListener('keydown', (e) => {
          if (e.keyCode === 40) {
            hasDownBeenPressed = true;
          }
        });
  
        google.maps.event.addDomListener(searchInput, 'keydown', (e) => {
          
          e.cancelBubble = true;
        
          if (e.keyCode === 13 || e.keyCode === 9) {
            if (!hasDownBeenPressed && !e.hasRanOnce) {
              google.maps.event.trigger(e.target, 'keydown', {
                  keyCode: 40,
                  hasRanOnce: true,
              });
            }
          }
        });
  
        searchInput.addEventListener('focus', () => {
          hasDownBeenPressed = false;
          searchInput.value = '';
        });
        
  
        this.autoComplete.addListener("place_changed", () => {
          this.ngZone.run(() => {
            let place = this.autoComplete.getPlace();
    
            if (place.geometry === undefined || place.geometry === null) {
              return;
            }
            searchInput.value = place.formatted_address;
            this.corpInfo.address = place.formatted_address;
          });
        });
      });   
    }
  }

  setPage(page: number) {
    if(this.corpInfo.contactList == null) return;
    this.contactPager = this.pagerService.getPager(this.contactList.length, page, 10);

    // if (page < 1) {
    //   return;
    // } 

    this.contactPagedItems =this.contactList.slice(this.contactPager.startIndex, this.contactPager.endIndex + 1);
  }

  
  getForwarderInfo(info) {
    this.corpInfo = info;
    
    if(info.officeList.length > 0) {
      this.officeList = info.officeList;
    } else {
      this.officeList.push(new Office2());
      console.log(this.officeList)
    }
    
    this.licenseList = info.licenseList;
    this.shipperList = info.shipperList;
    this.regNumberTemp = info.corpRegNo;
    this.corpId = this.corpInfo.corpId;
    this.contactList = info.contactList;

    if(this.corpInfo.liner && this.corpInfo.liner.lineCd){
      this.changeBeforeLineCd = this.corpInfo.liner.lineCd;
    }
    
    // this.specialityListForCcs = _.filter(info.specialityList, (speciality:Speciality) =>{
    //   if(speciality.purposeCd != null && speciality.purposeCd == 1){
    //     return speciality;
    //   }
    // });

    // info.specialityList = _.filter(info.specialityList, (speciality:Speciality) =>{
    //   if(speciality.purposeCd == null || speciality.purposeCd == 0){
    //     return speciality;
    //   }
    // });

    // this.regionListForCcs = _.filter(info.regionList, (region:Region) =>{
    //   if(region.purposeCd != null && region.purposeCd == 1){
    //     return region;
    //   }
    // });

    // info.regionList = _.filter(info.regionList, (region:Region) =>{
    //   if(region.purposeCd == null || region.purposeCd == 0){
    //     return region;
    //   }
    // });

    this.regionListForCcs = info.regionList

    this.setPage(1);

    this.getReqModifyList(this.corpInfo.corpId);
  }

  getReqModifyList(corpId:number){
    this.forwarderService.getReqModifyTempList(corpId).subscribe(
        resp =>{
          if(resp.result){
            this.reqModifyTempList = resp.data;
            this.setCorpTempPage(1);
          }
        }
    )
  }

  setLicenseItemList(data) {
    this.licenseItemList = _.map(data, (license, index) => {
      license.value = license.itemId;
      license.label = license.itemNm + (license.remark ? ' (' + license.remark + ')' : '');
      return license;
    });
  }

  setLicenseItem(event, index) {
    this.licenseList[index] = {
      isChecked: false,
      licenseId: event.licenseId,
      itemId: event.itemId,
      itemNm: event.itemNm,
      licenseRemark: event.remark,
      remark: null
    }
  }

  regNumSearch() {
    if(_.isEmpty(this.regNumberTemp)) {      
      $.sweetModal({
        content: '사업자등록번호를 입력해 주십시오.',        
        icon: $.sweetModal.ICON_WARNING
      });
      return;
    }

    this.forwarderService.findRegNo(this.regNumberTemp).subscribe(      
      resp => {
        this.regNumberCheck = resp.data;
        if(resp.data) {
          $.sweetModal({
            content: '사업자등록번호가 중복되었습니다. 다른 번호로 변경해 주십시오.',            
            icon: $.sweetModal.ICON_WARNING
          });
          this.regNumberCheck = resp.data;
        } else {
          $.sweetModal({
            content: '사업자등록번호가 중복되지 않았습니다. 계속 진행해 주십시오.',
            icon: $.sweetModal.ICON_WARNING
          });

          this.corpInfo.corpRegNo = this.regNumberTemp;          
        }
      }
    )
  }

  uploadRegFile(e) {
    if(this.corpInfo.corpId != null) {
      this.forwarderService.postCorpReg(this.corpId, this.uploader2);
      this.uploader2.onCompleteItem = (item:any, response:any, status:any, headers:any) => {
        var responsePath = JSON.parse(response);
        this.getCorpInfo(this.corpId);
      };
      this.uploader2.onErrorItem = (item:any, response:any, status:any, headers:any) => {
        var responsePath = JSON.parse(response);
        this.getCorpInfo(this.corpId);
        $.sweetModal({
          content: responsePath.errorMsg,
          icon: $.sweetModal.ICON_WARNING
        });
      };
    }
  }

  deleteRegFile() {
    this.forwarderService.delCorpReg(this.corpId, this.corpInfo.corpRegNo).subscribe(
      resp => {
        if(resp.result) {
          this.corpInfo.corpRegFile = null;
          if(this.uploader2.queue[0] != null) this.uploader2 = new FileUploader({});
        } else {
          $.sweetModal({
            content: resp.errorMsg,
            icon: $.sweetModal.ICON_WARNING
          });
        }
      }
    );
  }

  uploadPicFile(e) {
    var reader = new FileReader();
    reader.onload = function (e) {
      $('#img-logo').attr('src', _.get(e.target, 'result'));
    }

    const files = e.target.files;
    reader.readAsDataURL(files[0])

    if(this.corpInfo.corpId != null) {
      this.forwarderService.postCorpLogo(this.corpId, this.uploader);
      this.uploader.onCompleteItem = (item:any, response:any, status:any, headers:any) => {
        var responsePath = JSON.parse(response);
        this.getCorpInfo(this.corpId);
      };
      this.uploader.onErrorItem = (item:any, response:any, status:any, headers:any) => {
        var responsePath = JSON.parse(response);
        this.getCorpInfo(this.corpId);
        $.sweetModal({
          content: responsePath.errorMsg,
          icon: $.sweetModal.ICON_WARNING
        });
      };
    }
    
  }

  showFileUpload() {
    this.showFileUploadModal = true;
  }

  hideFileUpload() {
    this.showFileUploadModal = false;
  }

  uploadCorpFile(e) {    
    this.fileUpLoading = true;
    const formData = new FormData();
    formData.append('file', this.corpFileForm.value.file);
    formData.append('fileTitle', this.corpFileForm.value.fileTitle);
    this.forwarderService.postCorpFiles(this.corpId, formData, resp => {
      this.fileUpLoading = false;
      this.hideFileUpload();
      this.corpFileForm.reset();
      this.getCorpFile();
      this.alertService.success('저장이 완료 되었습니다.');
    },
    err => {
      this.fileUpLoading = false;
      this.alertService.error('저장이 실패되었습니다. 다시 시도해 주세요.');
    });
  }

  handleClickFileDownload(file: CorpFile) {
    this.apiService.getToken(res => {
      const access_token = sessionStorage.getItem('_vcd');
      if (access_token) {
        let url = REST_API_REQUEST_CALL_URL.API_INNER + 'corporation/file/' + this.corpId + '/' + file.corpFileId + '&token=' + access_token;
        var link = document.createElement("a");
        link.download = url;
        link.href = url;
        link.click();
      }
    });
  }

  handleClickFileDelete(fileId) {
    this.forwarderService.delCorpFile(this.corpId, fileId, resp => {
      this.alertService.success('파일이 삭제되었습니다.');
      this.getCorpFile();
    }, 
    err => {
      this.alertService.error('파일이 삭제가 실패했습니다. 다시 시도해 주세요.');
    });
  }

  checkTableAll(table, checked) {
    if (!this.corpInfo) return;
    let list = this.getTableDataList(table);
    if (_.isEmpty(list)) return;

    for (let i = 0 ; i < list.length ; i++) {
      list[i].isChecked = checked;
    }
  }

  getTableDataList(table) {
    let list = null;

    if (table == 'office') {
      list = this.officeList;
    } else if (table == 'license') {
      list = this.licenseList;
    } else if (table == 'shipper') {
      list = this.shipperList;
    } else if (table == 'contact') {
      list = this.contactList;
    }
    return list;
  }

  setTableData(table, index, value) {
    if (!this.corpInfo) return;
    let list = this.getTableDataList(table);

    if (list && list[index]) {
      list[index].isChecked = value;
    }
  }

  addOffice() {
    this.officeList.push(new Office2());
  }

  addLicense() {
    this.licenseList.push(new License2());
  }  

  addShipper() {
    this.shipperList.push(new Shipper2());
  }

  addContact(){
    if(this.corpInfo.liner == null || this.corpInfo.liner.lineCd == null) return;

    let idx:number = 0;
    if(this.contactList.length > 0) {
      let temp = this.contactList[this.contactList.length-1];
      idx = temp.seq + 1;
    }
    this.contactList.push(new Contact2(this.corpInfo.liner.lineCd, this.corpInfo.liner.lineNm, idx));
    this.setPage(this.contactPager.endPage);
  }

  delRow(table) {
    if (!this.corpInfo) return;
    let list = this.getTableDataList(table);
    if (_.isEmpty(list)) return;
    for (let i = 0 ; i < list.length ; i++) {
      if (list[i].isChecked) {
        list.splice(i, 1);
        i--;
      }
    }
    if(table == 'contact'){
      this.setPage(1);
    }
  }
  
  getThisItemIsCheckd(itemId) {
    if(_.findIndex(this.corpInfo.specialityList, {itemId: itemId}) >= 0) {
      return 'checked';
    } else {
      return null;
    }
  }

  onChangeSpc(specialityItem, checked) {
    if (checked) {
      this.corpInfo.specialityList.push(specialityItem);
    } else {
      let index = _.findIndex(this.corpInfo.specialityList, {itemId: specialityItem.itemId});
      if (specialityItem.itemId == 23) this.corpInfo.specialityList[index].remark = null;
      this.corpInfo.specialityList.splice(index, 1);
    }

  }

  onChangeInputContact(index, fieldNm, value) {
    this.contactPagedItems[index][fieldNm] = value;
  }

  isDisabled(spcItemId) {
    const specialityList = this.corpInfo.specialityList;

    if (spcItemId === 1) {
      let find = _.find(specialityList, (spc) => {
        return (spc.itemId == 4)
      });

      if (find) return true;
      else return false;
    } else if (spcItemId === 2) {
      let find = _.find(specialityList, (spc) => {
        return (spc.itemId == 4 || spc.itemId == 5)
      });

      if (find) return true;
      else return false;
    } else if (spcItemId === 3) {
      let find = _.find(specialityList, (spc) => {
        return (spc.itemId == 5)
      });

      if (find) return true;
      else return false;
    } else if (spcItemId === 4) {
      let find = _.find(specialityList, (spc) => {
        return (spc.itemId == 1 || spc.itemId == 2 || spc.itemId == 5 || spc.itemId == 6)
      });

      if (find) return true;
      else return false;
    } else if (spcItemId === 5) {
      let find = _.find(specialityList, (spc) => {
        return (spc.itemId == 2 || spc.itemId == 3 || spc.itemId == 4 || spc.itemId == 6)
      });

      if (find) return true;
      else return false;
    } else if (spcItemId === 6) {
      let find = _.find(specialityList, (spc) => {
        return (spc.itemId == 4 || spc.itemId == 5 || spc.itemId == 7)
      });

      if (find) return true;
      else return false;
    } else if (spcItemId === 7) {
      let find = _.find(specialityList, (spc) => {
        return (spc.itemId == 6)
      });

      if (find) return true;
      else return false;
    }
    return false;
  }

  isEtcDisabled() {
    if (_.findIndex(this.corpInfo.specialityList, {itemId: 23}) >= 0 ) {
      return false;
    } else {
      return true;
    }
  }

  setEtcText(event) {
    let spcEtc = _.find(this.corpInfo.specialityList, {itemId: 23});
    if (!spcEtc) return;
    spcEtc.remark = event.target.value;
  }

  getEtcText() {
    let spcEtc = _.find(this.corpInfo.specialityList, {itemId: 23});
    if (!spcEtc) return null;
    else return spcEtc.remark;
  }

  addNewAutocomplete(index) {
    var input = document.getElementById('office' + index); 
    var autocomplete = new google.maps.places.Autocomplete(input, {fields: ["name", "formatted_address"]});
    this.sendGmapLog();
    
    let hasDownBeenPressed = false;
    
    input.addEventListener('keydown', (e) => {
      if (e.keyCode === 40) {
        hasDownBeenPressed = true;
      }
    });

    google.maps.event.addDomListener(input, 'keydown', (e) => {
      
      e.cancelBubble = true;
    
      if (e.keyCode === 13 || e.keyCode === 9) {
        if (!hasDownBeenPressed && !e.hasRanOnce) {
          google.maps.event.trigger(e.target, 'keydown', {
              keyCode: 40,
              hasRanOnce: true,
          });
        }
      }
    });

    input.addEventListener('focus', () => {
      hasDownBeenPressed = false;
      $(input).value = '';
    });
    

    autocomplete.addListener("place_changed", () => {
      this.ngZone.run(() => {
        let place = autocomplete.getPlace();

        if (place.name=== undefined || place.name === null) {
          return;
        }
        $(input).value = place.formatted_address;
        this.officeList[index].address = place.formatted_address;
      });
    });
  }

  getTypeNm() {
    switch (this.corpInfo.typeCd) {
      case 1:
        return 'FORWARDER';
      case 2:
        return 'OCEAN_LINER';
      case 3:
        return 'CERTIFIED_CUSTOMS_BROKER';
      case 4:
        return 'SHIPPER';
      case 5:
        return 'EXPRESS_DELIVERY';
      case 6:
        return 'UNLOADER';
      case 7:
        return 'STOREHOUSE';
      case 8:
        return 'LOGISTICS_IT';
      case 9:
        return 'AGENCY_ASSOCIATION';
      case 11:
        return 'PACKING';
      case 14:
          return 'TEX_ACCOUNTANT';
      case 99:
        return 'OTHER';
      default: 
        return 'FORWARDER';
    }
  }
  
  postCorpInfo(type) {

    
    // if(this.corpInfo.corpIntrdc != null && this.corpInfo.corpIntrdc.length > 3000) {
    //   $.sweetModal({
    //     content: '회사 소개는 최대 3000 글자만 가능합니다.',
    //     icon: $.sweetModal.ICON_WARNING,
    //   })
    //   return;
    // }

    this.isSaving = true;
    
    
    if(this.corpInfo.typeCd == 2){
      //선사인 경우
      this.licenseList = null;
      this.shipperList = null;
      this.specialityItemList = _.filter(this.specialityItemList, (speciality:Speciality)=>{
        if(speciality.itemTpCd == 2) return true;
      });
    }else{
      //선사가 아닌 경우
      this.contactList = null;
      this.specialityItemList = _.filter(this.specialityItemList, (speciality:Speciality)=>{
        if(speciality.itemTpCd != 2) return true;
      });
    }

    //this.corpInfo.typeNm = this.getTypeNm();

    if(this.corpInfo.statusCd === 0 || this.corpInfo.statusCd === 1 || type === 'save') {
      this.regNumberCheck = false;
    }
    
    if(this.corpInfo.corpRegNo != this.regNumberTemp) {
      this.regNumberCheck = true;
    }

    if(this.corpInfo.corpRegNo === null) {
      $.sweetModal({
        content: '사업자 등록 번호는 필수입니다.',
        icon: $.sweetModal.ICON_WARNING
      });

      this.isSaving = false;

      return;
    }

    if(this.regNumberCheck) {
      $.sweetModal({
        content: '사업자등록번호 중복확인을 해 주세요.',
        icon: $.sweetModal.ICON_WARNING
      });

      this.isSaving = false;

      return;
    }

    this.corpInfo.officeList = new Array();
    this.corpInfo.licenseList = new Array();
    this.corpInfo.shipperList = new Array();
    this.corpInfo.contactList = new Array();

    if(this.officeList) {
      for(let i = 0; i<this.officeList.length; i++) {
        var office: Office = new Office();
        office = _.omit(this.officeList[i], 'isChecked');
        this.corpInfo.officeList.push(office);
      }
    }

    if(this.licenseList) {
      for(let i = 0; i<this.licenseList.length; i++) {
        var license: License = new License();
        license = _.omit(this.licenseList[i], 'isChecked');
        this.corpInfo.licenseList.push(license);
      }
    }

    if(this.shipperList) {
      for(let i = 0; i<this.shipperList.length; i++) {
        var shipper: Shipper = new Shipper();
        shipper = _.omit(this.shipperList[i], 'isChecked');
        this.corpInfo.shipperList.push(shipper);
      }
    }

    if(this.contactList) {
      for(let i = 0; i<this.contactList.length; i++) {
        var contact: Contact = new Contact();
        contact = _.omit(this.contactList[i], 'isChecked');
        this.corpInfo.contactList.push(contact);
      }
    }

    if(this.corpInfo.regUser != null && !this.corpInfo.regUser.userId) this.corpInfo.regUser = null;

    if(this.corpInfo.specialityList){
      this.corpInfo.specialityList = _.map(this.corpInfo.specialityList, (s:Speciality) =>{
        s.purposeCd = 0;
        return s;
      });
    }

    if(this.corpInfo.regionList){
      this.corpInfo.regionList = _.map(this.corpInfo.regionList, (r:Region) =>{
        r.purposeCd = 0;
        return r;
      });
    }

    if(this.corpInfo.corpId != null) {

      if(type == 'request'){
        this.corpInfo.statusCd = 0;
      }

      this.forwarderService.postCorpInfo(this.corpId, this.corpInfo).subscribe(
        resp => {
          if(resp.result) {
            $.sweetModal({
              content: '저장되었습니다.',
              icon: $.sweetModal.ICON_SUCCESS,
            })
          } else {
            $.sweetModal({
              content: resp.errorMsg,
              icon: $.sweetModal.ICON_WARNING
            })
          }
          this.isSaving = false;
          this.getCorpInfo(this.corpId);
        }
      );
    }else{
      this.corpInfo.statusCd = 0;

      this.forwarderService.postCorpInfo(-1, this.corpInfo).subscribe(
        resp => {
          if(resp.result){
            this.alertService.success('저장이 완료 되었습니다.');
          }else{
            this.alertService.success('저장이 실패 되었습니다.');
          }
          this.router.navigate(['/fwdr/list']);

          this.isSaving = false;
        });
      
    }
  }
  
  handleShowCompanyUsers() {
    if(this.showCompanyUsers) {
      this.showCompanyUsers = false;
    } else {
      this.showCompanyUsers = true;
    }
  }

  handleShowCfs() {
    if(this.showCfs) {
      this.showCfs = false;
    } else {
      this.showCfs = true;
    }    
  }

  handleShowCorpTemp() {
    if(this.showCorpTemp) {
      this.showCorpTemp = false;
    } else {
      this.showCorpTemp = true;
    }
  }

  fileUpload(index){
    if(this.corpId == null || this.corpId == undefined || this.corpId == -1){
      $.sweetModal({
        content: '저장을 완료한 후 파일을 등록해주세요.',        
        icon: $.sweetModal.ICON_WARNING
      });
      return ;
    }

    if(index == 1) this.fileInput1.nativeElement.click();
    else this.fileInput2.nativeElement.click();
  }

  updateStatus(statusCd){
    
    let confirmMsg = "승인";
    if(statusCd == 2){
      confirmMsg = "취소/거절";
    }
    
    let that = this;
    $.sweetModal.confirm(confirmMsg + " 상태로 변경하시겠습니까?", function() {
      let fwdr:Corporation = new Corporation();
      fwdr.statusCd = statusCd;
      fwdr.corpId = that.corpId;

      that.updateCorpStatusSub = that.forwarderService.updateFwdrCorpStatusCd(fwdr).subscribe(
        res=>{
          if(res.result){
            that.alertService.success('상태 변경이 완료되었습니다.');
            that.forwarderService.getCorpInfo(that.corpId).subscribe(
              resp => {
                if(resp.result) {
                  that.getForwarderInfo(resp.data);
                  that.forwarderWarning = null;
                  window.scrollTo(0, 0);
                } else {
                  that.forwarderWarning = resp.errorMsg;
                }
              }
            );
          }
        }
      );
    });
  }

  parseToDate(dateStr:string) {
    return moment(dateStr, 'YYYYMMDD').toDate();
  }

  movePromotion(){
    this.router.navigate(['/fwdr/promotion', this.corpId]);
  }

  replaceText(event, type) {
    let replaceValue = event.target.value.replace(/[^0-9.]/g, '');

    if(type == 'regNumer') {
      this.regNumberTemp = replaceValue;
      event.target.value = replaceValue;
    } else if(type == 'tel') {
      this.corpInfo.tel = replaceValue;
      event.target.value = replaceValue;
    } else if(type == 'fax') {
      this.corpInfo.fax = replaceValue;
      event.target.value = replaceValue;
    } else {
      return;
    }
  }

  closeCorpCnsltnSetting(){
    this.isOpenCcs = false;
  }

  openCnsltnSetting(){
    this.isOpenCcs = true;
  }

  

  closeServiceRoute(){
    this.isServiceRouteOpen = false;
  }

  openServiceRoute(){
    this.isServiceRouteOpen = true;
  }


  selectOceanLine(value:OceanLine){
    if(value){
      this.corpInfo.linerCd = value.lineCd;
      this.corpInfo.corpNm = value.lineNm;
      this.corpInfo.liner = new OceanLine();

      this.corpInfo.liner.lineCd = value.lineCd;
      this.corpInfo.liner.lineNm = value.lineNm;
      this.corpInfo.liner.lineNm2 = value.lineNm2;
      this.corpInfo.liner.lineNmKr = value.lineNmKr;
      this.corpInfo.liner.alliance = value.alliance;
      this.corpInfo.liner.cntryCd = value.cntryCd;
      this.corpInfo.liner.cntryNm = value.cntryNm;    
	    this.corpInfo.liner.corpId = this.corpInfo.corpId;
    }else{
      this.corpInfo.linerCd = null;
      this.corpInfo.corpNm = null;
      for(let linerInfo in this.corpInfo.liner) {
        this.corpInfo.liner[linerInfo] = null;
      }
    }
  }

  openChangeRegUserModel(){
    this.userService.getUserList('NOT_LEAVE').subscribe(res=>{
      if(res){
        this.userList = res;
      }
    });
    this.isOpenChangeUserModal = true;
    this.selectedUser = null;
  }

  delRegUser() {
    Util.confirm("등록자를 삭제하시겠습니까?", () => {
      this.forwarderService.delCorpRegUser(this.corpInfo.corpId).subscribe(resp =>{
        if(resp.result){
          this.alertService.success("삭제가 완료 되었습니다.");
          this.getCorpInfo(this.corpId);
        }
      });
    }, () =>{});
  }

  closeChangeRegUserModel(){
    this.isOpenChangeUserModal = false;
    this.selectedUser = null;
    if(this.userSelector){
      this.userSelector.close();
    }
  }

  selecedUser(user:UserModel){
    this.selectedUser = user;
  }

  changeCnsltnReqUser(){
    if(!this.corpId){
      return ;
    }
    
    Util.confirm("등록자를 변경하시겠습니까?", () => {
      this.forwarderService.changeCorpRegUser(this.corpInfo.corpId, this.selectedUser.userId).subscribe( resp =>{
        if(resp.result){
          this.alertService.success("요청자 변경이 완료 되었습니다.");
          this.getCorpInfo(this.corpId);
        }
        this.isOpenChangeUserModal = false;
      });
    }, () =>{});
  }

}


// WEBPACK FOOTER //
// ./src/app/containers/fwdr/detail/corp-setting.ts